import { createAction, props } from "@ngrx/store";
import { IFinantialReceiptsReport } from "src/app/shared/interfaces/finantial-receipts-report/ifinantial-receipts-report";

enum FinantialReceiptsReportActionType {
    LOAD_FINANTIAL_RECEIPTS_REPORT = '[receita financeiro] load notas fiscais report from api',
    LOAD_FINANTIAL_RECEIPTS_REPORT_SUCCESS = '[receita financeiro] load notas fiscais report from api return success'
}


const loadFinantialReceiptsReport = createAction(
    FinantialReceiptsReportActionType.LOAD_FINANTIAL_RECEIPTS_REPORT
);

const loadFinantialReceiptsReportSuccess = createAction(
    FinantialReceiptsReportActionType.LOAD_FINANTIAL_RECEIPTS_REPORT_SUCCESS,
    props<{ finantial_receipts_report: IFinantialReceiptsReport }>()
);

export const finantialReceiptsReportActions = {
    loadFinantialReceiptsReport,
    loadFinantialReceiptsReportSuccess
}